export default "/app/plugins/bv-catalog/dist/images/plyr.svg?45c9eb7ca1ecbd0c1a7e9ad33c98f712";